(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ibm-gantt-chart"] = factory();
	else
		root["ibm-gantt-chart"] = factory();
})(this, function() {
return 